export default __webpack_public_path__ + "static/media/Communication.b4580c55.png";